import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import ProfissaoService from "./profissaoService"
import FormList from 'base/FormList'

export default function ProfissaoList() {

    const [service] = useState(() => new ProfissaoService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_prof',
        dsName: 'descricao_prof',
        mainField: { name: 'descricao_prof', label: 'Descrição' },
        advFields: [
            { name: 'codigo_prof', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_prof', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="descricao_prof" sortable header="Descrição"></Column>
        </FormList >
    )
}
